export interface ImcCalculatorValue {
    pesoKg: number | null
    alturaCm: number | null
}

export function createDefaultImcCalculatorValue(): ImcCalculatorValue {
    return { pesoKg: null, alturaCm: null }
}

export function isImcCalculatorValueEmpty(value: ImcCalculatorValue | null | undefined): boolean {
    return value?.pesoKg == null || value?.alturaCm == null
}

export function computeImc(pesoKg: number | null, alturaCm: number | null): number | null {
    if (pesoKg == null || alturaCm == null || pesoKg <= 0 || alturaCm <= 0) return null
    const alturaM = alturaCm / 100
    return pesoKg / (alturaM * alturaM)
}

export interface ImcClassification {
    tipo: string
    risco: string
}

const IMC_CLASSIFICATION_TABLE: (ImcClassification & { maxImc: number | null })[] = [
    { maxImc: 18.5, tipo: 'Abaixo do peso', risco: 'Baixo (mas com risco de outros problemas, como desnutrição)' },
    { maxImc: 25, tipo: 'Peso normal', risco: 'Médio (o menor risco para a saúde)' },
    { maxImc: 30, tipo: 'Sobrepeso', risco: 'Aumentado' },
    { maxImc: 35, tipo: 'Obesidade Grau I', risco: 'Moderado' },
    { maxImc: 40, tipo: 'Obesidade Grau II (severa)', risco: 'Grave' },
    { maxImc: null, tipo: 'Obesidade Grau III (mórbida)', risco: 'Muito grave' },
]

export function classifyImc(imc: number): ImcClassification {
    const match = IMC_CLASSIFICATION_TABLE.find((row) => row.maxImc === null || imc < row.maxImc)
    return match ?? IMC_CLASSIFICATION_TABLE[IMC_CLASSIFICATION_TABLE.length - 1]
}

export function parseBRNumber(raw: string): number | null {
    const cleaned = raw.trim().replace(/\./g, '').replace(',', '.')
    if (cleaned === '') return null
    const parsed = Number(cleaned)
    return Number.isFinite(parsed) ? parsed : null
}

export function formatBRNumber(value: number | null, decimals = 2): string {
    return value == null ? '' : value.toFixed(decimals).replace('.', ',')
}
